"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _modal = _interopRequireDefault(require("../Modal/modal"));

var _dialog = _interopRequireDefault(require("../Dialog/dialog"));

var _illustration = _interopRequireDefault(require("../Illustration/illustration"));

var _alertActions = require("./alertActions");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ILLUS_ERROR = 'error';
var ILLUS_WARN = 'exclamation';
var ILLUS_INFO = 'info';
var ILLUS_SUCCESS = 'success';

var Alert = function Alert(_ref) {
  var success = _ref.success,
      error = _ref.error,
      info = _ref.info,
      warning = _ref.warning,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["success", "error", "info", "warning", "onDismiss", "children"]);

  return _react.default.createElement(_modal.default, _extends({
    small: true,
    onDismiss: onDismiss
  }, (0, _getNativeProps.default)(props)), _react.default.createElement(_dialog.default, null, _react.default.createElement(_dialog.default.Content, null, _react.default.createElement(_illustration.default, {
    name: getIllustration({
      success: success,
      error: error,
      info: info,
      warning: warning
    })
  }), children)));
};

var AlertTitle = function AlertTitle(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("h2", null, children);
};

var AlertMessage = function AlertMessage(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("p", null, children);
};

function getIllustration(_ref4) {
  var success = _ref4.success,
      info = _ref4.info,
      warning = _ref4.warning,
      error = _ref4.error;

  if (success) {
    return ILLUS_SUCCESS;
  } else if (info) {
    return ILLUS_INFO;
  } else if (warning) {
    return ILLUS_WARN;
  } else if (error) {
    return ILLUS_ERROR;
  } else {
    return ILLUS_INFO;
  }
}

AlertTitle.displayName = 'Alert.Title';
AlertMessage.displayName = 'Alert.Message';
Alert.Title = AlertTitle;
Alert.Message = AlertMessage;
Alert.Actions = _alertActions.AlertActions;
var exclusiveStateProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('success', 'error', 'warning', 'info');
Alert.propTypes = {
  /** {---} Sequence of:
   * @@<Alert.Title>@@ (required, max: 1),
   * @@<Alert.Message>@@ (required, max: 1),
   * @@<Alert.Actions>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,

  /** {bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@ */
  success: exclusiveStateProps,

  /** {bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@ */
  error: exclusiveStateProps,

  /** {bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@ */
  info: exclusiveStateProps,

  /** {bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@ */
  warning: exclusiveStateProps,
  onDismiss: _propTypes.func.isRequired
};
var _default = Alert;
exports.default = _default;
Alert.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Alert",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of:\n@@<Alert.Title>@@ (required, max: 1),\n@@<Alert.Message>@@ (required, max: 1),\n@@<Alert.Actions>@@ (optional, max: 1)"
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@"
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@error@@ @@warning@@ @@info@@"
    },
    "onDismiss": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};